import React from "react";
import { Link } from "react-router-dom";
import { isLink, isStatus, getStatusRowStyle } from "../../../../ui/helpers";

export function renderTagsRow(headings, item) {
  return headings.map(([key]) => (
    <td
      key={key}
      className={`text-center no-line border-0 px-5 py-5 ${isStatus(key) &&
        getStatusRowStyle(item)}`}
    >
      {isLink(key) ? (
        <Link className="text-dark" to={`/tags/${item.id}`}>
          {item[key]}
        </Link>
      ) : (
        item[key]
      )}
    </td>
  ));
}

export const modifyRelatedCrops = data => {
  return data.map(crop => ({
    label: `${crop.name} ${crop.variety} - ${crop.grade}`,
    id: crop.id
  }));
};
